import Region from '../../../constants/region';
import { TCJ_REGIONS } from '../../../constants/region-utils';
import cdi from './cdi';
import prairie from './prairie';
import tcj from './tcj';

const tcjConfig = TCJ_REGIONS.map((region) => [region, tcj]);

export default {
    [Region.CDI]: cdi,
    [Region.PRAIRIE]: prairie,
    ...Object.fromEntries(tcjConfig),
};
